import './tab-selection.scss'
